import React from 'react'
import { toPng } from 'html-to-image'
import jsPDF from 'jspdf'
import { exportTableToExcel } from '../../utils/exportTableToExcel'

interface ExportPreviewProps {
  onChange: (data: any) => void
  exportRef: HTMLDivElement | null
  shortRange: Record<string, any>
  extendedRange: Record<string, any>
  shortTimes: string[]
  extendedTimes: string[]
  roadRange : any
  renderTransposedTable: (
    range: Record<string, any>,
    isExtendedForecast: boolean | false,
    isRoadData: boolean | false,
    isVPData: boolean | false,
    clip: boolean
  ) => JSX.Element
  readableDate: string
  coordinates: string[],
  vpData: any
}

export const MissionCastExportPreview: React.FC<ExportPreviewProps> = ({
  exportRef,
  shortRange,
  extendedRange,
  roadRange,
  renderTransposedTable,
  readableDate,
  coordinates,
  vpData
}) => {

  return (
    <div id="missioncast-preview" className="bg-white" ref={exportRef}>
      <div className="flex flex-row justify-between" id="title-div">
        <div className="flex flex-col">
          <span className="text-base text-left font-semibold date">
            Date: {readableDate}
          </span>
          <span className="text-base text-left font-semibold coordinates">
            Coordinates:{' '}
            {' (' + coordinates[0] + ', ' + coordinates[1] + ') '}
          </span>
        </div>
      </div>
      <div>
        <h2 className="font-bold text-md">Short Range Forecast (0-24 hrs)</h2>
        {renderTransposedTable(shortRange, false, false, false, true)}
      </div>
      <div>
        <h2 className="font-bold text-md">
          Extended Range Forecast (24-144 hrs hrs)
        </h2>
        {renderTransposedTable(extendedRange, true, false, false, true)}
      </div>
      {roadRange.length > 0 && (
        <div>
          <h2 className="font-bold text-md">
            Road Weather Forecast (0-24 hrs)
          </h2>
          {renderTransposedTable(roadRange, false, true, false, true)}
        </div>
      )}
      {vpData.length > 0 && (
        <div>
          <h2 className="font-bold text-md">
            Vertical Wind Profile (NowCast)
          </h2>
          {renderTransposedTable(vpData, false, false, true, true)}
        </div>
      )}

      <div className="text-left font-bold flex flex-col">
        <div>NA = Data is not available. Condition is unknown. </div>
        <div>
          NONE = The condition (Ceiling or Wind Gusts) is not present.{' '}
        </div>
        <div>NRL = The condition (Slickness) is NORMAL. </div>
      </div>
    </div>
  )
}
